import { option, root } from './SegmentedControl.css'

export type SegmentedOption<T extends string> = {
  value: T
  label: string
}

export type SegmentedControlProps<T extends string> = {
  value: T
  options: ReadonlyArray<SegmentedOption<T>>
  onChange: (value: T) => void
  ariaLabel?: string
}

export function SegmentedControl<T extends string>({
  value,
  options,
  onChange,
  ariaLabel,
}: SegmentedControlProps<T>) {
  return (
    <div className={root} role="tablist" aria-label={ariaLabel}>
      {options.map((item) => {
        const active = item.value === value
        return (
          <button
            key={item.value}
            type="button"
            role="tab"
            aria-selected={active}
            className={option({ active })}
            onClick={() => {
              onChange(item.value)
            }}
          >
            {item.label}
          </button>
        )
      })}
    </div>
  )
}
